import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CounterState {
  value: number;
}

interface UserState {
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  user: number | null;
  userData: any;
}

interface BannerState {
  isVisible: boolean;
}

interface AppState {
  counter: CounterState;
  user: UserState;
  userData: any;
  banner: BannerState;
}

const initialCounterState: CounterState = {
  value: 0,
};

const initialUserState: UserState = {
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null,
  user: null,
  userData: null,
};

const initialBannerState: BannerState = {
  isVisible: true,
};

const appSlice = createSlice({
  name: 'app',
  initialState: {
    counter: initialCounterState,
    user: initialUserState,
    userData: null,
    banner: initialBannerState,
  } as AppState,
  reducers: {
    increment: (state) => {
      state.counter.value += 1;
    },
    decrement: (state) => {
      state.counter.value -= 1;
    },
    setValue: (state, action: PayloadAction<number>) => {
      state.counter.value = action.payload;
    },
    login: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        user?: number | null;
        userData?: any;
      }>,
    ) => {
      state.user.isAuthenticated = true;
      state.user.accessToken = action.payload.accessToken;
      state.user.refreshToken = action.payload.refreshToken;
      state.user.user = action?.payload?.user ?? null;
      state.userData = action?.payload?.userData ?? null;
    },
    logout: (state) => {
      state.user.isAuthenticated = false;
      state.user.accessToken = null;
      state.user.refreshToken = null;
      state.user.user = null;
    },
    setBannerVisibility: (state, action: PayloadAction<boolean>) => {
      state.banner.isVisible = action.payload;
    },
    updateAccessToken: (state, action: PayloadAction<string>) => {
      state.user.accessToken = action.payload;
    },
  },
});

export const {
  increment,
  decrement,
  setValue,
  login,
  logout,
  setBannerVisibility,
  updateAccessToken,
} = appSlice.actions;

export const appReducer = appSlice.reducer;
